export function getRegistrationDonationFloor(minimumDonation: number, itemsTotal: number): number {
  if (!Number.isFinite(minimumDonation) || minimumDonation <= 0) {
    return 0;
  }

  const normalizedItemsTotal = Number.isFinite(itemsTotal) && itemsTotal > 0 ? itemsTotal : 0;
  return Math.max(minimumDonation - normalizedItemsTotal, 0);
}

export function getRegistrationOrderShortfall(minimumDonation: number, orderTotal: number): number {
  if (!Number.isFinite(minimumDonation) || minimumDonation <= 0) {
    return 0;
  }

  const normalizedOrderTotal = Number.isFinite(orderTotal) && orderTotal > 0 ? orderTotal : 0;
  return Math.max(minimumDonation - normalizedOrderTotal, 0);
}

export function isRegistrationMinimumMet(minimumDonation: number, orderTotal: number): boolean {
  return getRegistrationOrderShortfall(minimumDonation, orderTotal) === 0;
}

function roundRegistrationPreset(amount: number): number {
  if (amount >= 1000) return Math.round(amount / 100) * 100;
  if (amount >= 100) return Math.round(amount / 50) * 50;
  if (amount >= 10) return Math.round(amount / 10) * 10;
  return Math.round(amount);
}

export function getRegistrationDonationPresets(
  basePresets: number[],
  minimumDonationFloor: number,
): number[] {
  const normalizedBasePresets = basePresets
    .filter((amount) => Number.isFinite(amount) && amount > 0)
    .map((amount) => roundRegistrationPreset(amount));
  const normalizedFloor =
    Number.isFinite(minimumDonationFloor) && minimumDonationFloor > 0 ? minimumDonationFloor : 0;

  const withFloor =
    normalizedFloor > 0 ? [normalizedFloor, ...normalizedBasePresets] : normalizedBasePresets;
  const filtered = withFloor.filter((amount) => amount >= normalizedFloor);

  if (filtered.length > 0) {
    return Array.from(new Set(filtered)).sort((left, right) => left - right);
  }

  if (normalizedFloor <= 0) {
    return Array.from(new Set(normalizedBasePresets)).sort((left, right) => left - right);
  }

  return Array.from(
    new Set([
      normalizedFloor,
      roundRegistrationPreset(normalizedFloor * 1.25),
      roundRegistrationPreset(normalizedFloor * 1.5),
      roundRegistrationPreset(normalizedFloor * 2),
    ]),
  ).sort((left, right) => left - right);
}
